export const testDecimals = (numberOfDecimals: number) => (value?: number) =>
  new RegExp(
    `^$|^-?\\s*(?=.*[0-9])\\d*(?:\\.\\d{1,${numberOfDecimals}})?\\s*$`
  ).test(value !== undefined ? value.toString() : '');

export const testYear = () => (value?: number) =>
  value !== undefined && /^$|\d{4}/.test(value.toString());
